import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/close_icon.png'


const _hoisted_1 = { class: "ingredients-dialog-overlay" }
const _hoisted_2 = { class: "ingredients-dialog-box" }
const _hoisted_3 = { class: "ingredients-dialog-box-area" }
const _hoisted_4 = { class: "ingredients-dialog-header-area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ingredients-dialog-title-text" }, "材料", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "ingredients-dialog-close-image-icon",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailIngredientsView = _resolveComponent("DetailIngredientsView")

  return (_openBlock(), _createBlock(_Transition, { name: "ingredients-dialog" }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", {
                class: "ingredients-dialog-close-image",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickClose(...args)))
              }, [
                _hoisted_6
              ])
            ]),
            _createVNode(_component_DetailIngredientsView, {
              class: "ingredients-dialog-list-area",
              content: _ctx.getContent(),
              themeList: _ctx.getThemeList(),
              varicationList: _ctx.getVariationList(),
              selectThemeType: _ctx.getSelectThemeType(),
              selectVariationType: _ctx.getSelectVariationType(),
              onClickTheme: _ctx.clickTheme,
              onClickVariation: _ctx.clickVariation
            }, null, 8, ["content", "themeList", "varicationList", "selectThemeType", "selectVariationType", "onClickTheme", "onClickVariation"])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showDialog]
      ])
    ]),
    _: 1
  }))
}